/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Zubair's Portfolio",
  description:
    "Native Android and AI developer: building production Android apps with Kotlin, Jetpack and Android Studio, and applying computer vision & deep learning (TensorFlow, PyTorch, OpenCV, TFLite) to create intelligent, scalable mobile solutions.",
  og: {
    title: "Zubair Ali Sandhu's Portfolio",
    type: "website",
    url: "http://zubairsandhu.dev/",
  },
};

//Home Page
const greeting = {
  title: "Zubair Ali Sandhu",
  logo_name: "Zubair Ali Sandhu",
  nickname: "Prospect",
  subTitle:
    "Native Android and AI developer: building production Android apps with Kotlin, Jetpack and Android Studio, and applying computer vision & deep learning (TensorFlow, PyTorch, OpenCV, TFLite) to create intelligent, scalable mobile solutions.",
  resumeLink:
    "https://drive.google.com/file/d/1s2W096bGlSDSp0-lpaCS8qrMjzGAPB0Z/view?usp=sharing",
  portfolio_repository: "https://github.com/Zubair-Ali-Sandhu/masterPortfolio",
  githubProfile: "https://github.com/Zubair-Ali-Sandhu",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/Zubair-Ali-Sandhu",
  // linkedin: "https://www.linkedin.com/in/zubair-ali-sandhu-1041a1247/",
  // gmail: "zubairali7893@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/share/1ByJrAZSo7/",
  // twitter: "https://x.com/ZUBAIRALISANDHU",
  // instagram: "https://www.instagram.com/zubair_ali_sandhu?igsh=MWxva3ZhdmNxa3ExbQ=="
  {
    name: "Upwork",
    link: "https://www.upwork.com/freelancers/~016451a137002d938a?viewMode=1",
    backgroundColor: "#6fda44", // Reference https://simpleicons.org/?q=upwork
  },

  {
    name: "Github",
    link: "https://github.com/Zubair-Ali-Sandhu",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/zubair-ali-sandhu-1041a1247/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Whatsapp",
    link: "https://wa.me/+923237988344",
    fontAwesomeIcon: "fa-whatsapp", // Reference https://fontawesome.com/icons/whatsapp?style=brands
    backgroundColor: "#25D366", // Reference https://simpleicons.org/?q=whatsapp
  },
  {
    name: "Gmail",
    link: "mailto:zubairali7893@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "X-Twitter",
    link: "https://x.com/ZUBAIRALISANDHU",
    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/share/1ByJrAZSo7/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link:
      "https://www.instagram.com/zubair_ali_sandhu?igsh=MWxva3ZhdmNxa3ExbQ==",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Android App Development",
      fileName: "AppDevelopmentImg",
      skills: [
        "⚡ Build and maintain native Android applications using Kotlin, Android Studio, and XML layouts",
        "⚡ Implement Android architecture components, Jetpack libraries, and MVVM design patterns",
        "⚡ Integrate REST APIs, Firebase services, and background workers for production-ready Android apps",
      ],
      softwareSkills: [
        {
          skillName: "Kotlin",
          fontAwesomeClassname: "devicon:kotlin",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "devicon:java",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Android",
          fontAwesomeClassname: "simple-icons:android",
          style: {
            color: "#3DDC84",
          },
        },
        {
          skillName: "XML",
          fontAwesomeClassname: "bi:filetype-xml",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: {
            color: "#339933",
          },
        },
      ],
    },
    {
      title: "System Design & Analysis",
      fileName: "DesignImg",
      skills: [
        "⚡ SRS & Requirements Engineering: Write clear SRS documents with functional and non-functional requirements.",
        "⚡ UML & System Diagrams: Create UML, DFDs, domain models, and architecture diagrams",
        "⚡ System Analysis: Convert business needs into well-documented software solutions",
      ],
      softwareSkills: [
        {
          skillName: "UML",
          fontAwesomeClassname: "material-icon-theme:uml",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Draw.io",
          fontAwesomeClassname: "vscode-icons:file-type-drawio",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "MS Visio",
          fontAwesomeClassname: "file-icons:microsoft-visio",
          style: {
            color: "#FF7C00",
          },
        },
        {
          skillName: "Data Flow Diagram",
          fontAwesomeClassname: "fluent-mdl2:dataflows-link",
          style: {
            color: "#000000",
          },
        },
      ],
    },
    {
      title: "Computer Vision & Deep Learning",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and computer vision tasks",
        "⚡ Experience of working with Computer Vision and NLP projects",
        "⚡ Good understanding of Deep Learning architectures such as CNNs, RNNs, Transformers and GANs",
      ],
      softwareSkills: [
        {
          skillName: "OpenCV",
          fontAwesomeClassname: "devicon:opencv",
          style: {
            backgroundColor: "transparent",
          },
        },

        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on  cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Deploying deep learning models on cloud to use on mobile devices",
      ],
      softwareSkills: [
        {
          skillName: "Supabase",
          fontAwesomeClassname: "skill-icons:supabase-dark",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },

        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Coursera",
      iconifyClassname: "simple-icons:coursera",
      style: {
        color: "#2A73CC",
      },
      profileLink:
        "https://www.coursera.org/user/7f07a82326a1ddff3aea7b2a1c4a187e",
    },
    {
      siteName: "Udemy",
      iconifyClassname: "simple-icons:udemy",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.udemy.com/user/zubair-ali-sandhu/",
    },
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://leetcode.com/u/Zubair_Ali_Sandhu/",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "FAST National University of Computer and Emerging Sciences",
      subtitle: "Bachelor’s in Computer Science  CGPA: 3.15/4",
      logo_path: "idMIXxx8N__1770238083141.jpeg",
      alt_name: "FAST NUCES",
      duration: "2022 - 2026",
      descriptions: [
        "⚡ I have studied Computer Science subjects like OOP,DS, Algorithms, DBMS, OS, CA, AI,Asssembly Language etc.",
        "⚡ Apart from this, I have done courses on Deep Learning,Generative AI, Computer Vision, Cloud Computing and Android Development.",
        "⚡ Earned a place on the Dean’s List (Spring 2023) with a CGPA of 3.59/4, reflecting strong commitment.",
      ],
      website_link: "https://www.nu.edu.pk/",
    },
    {
      title: "Pak Turk Maarif International Schools and Colleges",
      subtitle: "Intermediate in Computer Science",
      logo_path: "pakturk.jpg",
      alt_name: "Pak Turk Maarif International Schools and Colleges",
      duration: "2020 - 2022",
      descriptions: [
        "⚡ I studied Programming fundamentals and basics of C++ .",
        "⚡ Apart from this, I have also studied courses on physics,mathematics and literature.",
        "⚡ I was awarded with the position of 2nd position in the whole school in the final exams.",
      ],
      website_link: "https://pk.maarifschool.org/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/H8CPSFXAJD2G",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/EB4VJARK8647",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "Data Science",
      subtitle: "- Alex Aklson",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/PLEAPCSJBZT5",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Big Data",
      subtitle: "- Kim Akers",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "Advanced Data Science",
      subtitle: "- Romeo Kienzler",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Advanced ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "DL on Tensorflow",
      subtitle: "- Laurence Moroney",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Fullstack Development",
      subtitle: "- Jogesh Muppala",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "Kuberenetes on GCP",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    {
      title: "Cryptography",
      subtitle: "- Saurabh Mukhopadhyay",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "Cloud Architecture",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work and Volunteership",
  description:
    "I have experience as a freelance Android developer building AI-integrated mobile applications, and as a Teaching Assistant where I guided students through object-oriented programming concepts. I also actively contribute to my university community through volunteering at tech events like CTF competitions and job fairs.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Part Time Freelance Android Developer",
          company: "",
          company_url: "https://www.tiktok.com/en/",
          logo_path: "prime--briefcase.png",
          duration: "June 2025 - Present",
          location: "Remote",
          description:
            "Part-time freelance Android developer responsible for designing and developing AI Integrated Android applications using Kotlin and Java, implementing core features, fixing bugs, and delivering reliable, user-focused solutions while collaborating remotely with clients.",
          color: "#000000",
        },
        {
          title: "Teaching Assistant",
          company: "FAST National University of Computer and Emerging Sciences",
          company_url: "https://www.nu.edu.pk/",
          logo_path: "idMIXxx8N__1770238083141.jpeg",
          duration: "Jan 2024 - Aug 2024",
          location: "Faisalabad, Punjab",
          description:
            "Assisted students in understanding core C++ object-oriented programming concepts through guidance and problem-solving sessions, and designed, evaluated, and graded assignments and quizzes to assess learning and reinforce conceptual clarity. ",
          color: "#0879bf",
        },
      ],
    },
    // {
    //   title: "Internships",
    //   experiences: [
    //     {
    //       title: "Machine Learning Intern",
    //       company: "TikTok Inc.",
    //       company_url: "https://www.tiktok.com/en/",
    //       logo_path: "tiktok_logo.png",
    //       duration: "May 2022 - Aug 2022",
    //       location: "San Francisco, USA",
    //       description:
    //         "Building new features on the backend recommendation system, specifically ranking algorithms for Ads that touch hundreds of millions of people around the world. Improving online and offline content ranking algorithms by performing hard sample data replays for training steps.",
    //       color: "#000000",
    //     },
    //     {
    //       title: "Data Science Research Intern",
    //       company: "Delhivery Pvt. Ltd.",
    //       company_url: "https://www.delhivery.com/",
    //       logo_path: "delhivery_logo.png",
    //       duration: "May 2019 - Sept 2019",
    //       location: "Gurgaon, Haryana",
    //       description:
    //         "I have worked on project of predicting freight rates based on previous data. There were two objectives: (1) To build a forecasting engine to predict daily freight rates. (2) To embed feature in the model which can explain the seasonal major changes in freight rate based on regions and locations. I have closely worked with deep learning models in combination with statistical methods to create solution for this. At the end of internship, I had created model deployed on AWS EC2 with the use of Kafka stream jobs, ElasticSearch and PostgreSQL.",
    //       color: "#ee3c26",
    //     },
    //     {
    //       title: "Data Science Intern",
    //       company: "Intel Indexer LLC",
    //       company_url:
    //         "https://opencorporates.com/companies/us_dc/EXTUID_4170286",
    //       logo_path: "intel_logo.jpg",
    //       duration: "Nov 2018 - Dec 2018",
    //       location: "Work From Home",
    //       description:
    //         "This is financial Solution Company. I have made Supervised Learning model for the company which can perform time series analysis on Stock price data for 32 companies. I have built LSTM Neural Networks Model and trained the data of 32 companies for last 2 years. This model is also used for forecasting.",
    //       color: "#0071C5",
    //     },
    //   ],
    // },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Capture The Flag Event Volunteer",
          company: "FAST National University of Computer and Emerging Sciences",
          company_url: "https://www.nu.edu.pk/",
          logo_path: "idMIXxx8N__1770238083141.jpeg",
          duration: "Feb 2025",
          location: "Faisalabad, Punjab",
          description:
            "I volunteered for the Capture The Flag (CTF) event organized by the Cyber Security Society at FAST National University of Computer and Emerging Sciences. My role involved assisting in the setup and organization of the CTF competition, providing support to participants, and helping to ensure a successful and engaging cybersecurity event.",
          color: "#D83B01",
        },
        {
          title: "Usher for Job Fair 2024",
          company: "FAST National University of Computer and Emerging Sciences",
          company_url: "https://www.nu.edu.pk/",
          logo_path: "idMIXxx8N__1770238083141.jpeg",
          duration: "March 2024",
          location: "Faisalabad, Punjab",
          description:
            "I volunteered as an usher for the Job Fair 2024 organized by the FAST National University of Computer and Emerging Sciences. My responsibilities included guiding attendees, providing information about the event, and ensuring a smooth flow of activities during the job fair.",
          color: "#4285F4",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects make use of a vast variety of latest technology tools. My best experience is to create AI integrated mobile applications and Computer Vision projects.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "neuro-symbolic-sudoku-solver",
      name: "Neuro-Symbolic Sudoku Solver",
      createdAt: "2023-07-02T00:00:00Z",
      description: "Paper published in KDD KiML 2023",
      url: "https://arxiv.org/abs/2307.00653",
    },
    {
      id: "mdp-diffusion",
      name: "MDP-Diffusion",
      createdAt: "2023-09-19T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/mdp-diffusion/",
    },
    {
      id: "consistency-models",
      name: "Consistency Models",
      createdAt: "2023-10-12T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/consistency-models/",
    },
  ],
};

// Blogs Section
const blogsSection = {
  title: "My Blogs",
  subtitle:
    "I love to write and share my knowledge through blogs. Here are some of my articles.",
  blogs: [
    {
      slug: "neural-storyteller-image-captioning-seq2seq",
      title: "Neural Storyteller  Image Captioning with Seq2Seq Architecture",
      description:
        "Built an image captioning system from scratch using a Seq2Seq model with ResNet-50 encoder and LSTM decoder, trained on the Flickr30k dataset, and deployed it as an interactive Gradio app on Hugging Face Spaces.",
      coverImage:
        "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800",
      date: "June 24, 2025",
      readTime: "12 min read",
      tags: [
        "Generative AI",
        "Multimodal",
        "Computer Vision",
        "NLP",
        "PyTorch",
        "Seq2Seq",
        "Image Captioning",
      ],
      content: `
## Introduction

Image captioning sits at the intersection of computer vision and natural language processing  a model needs to *see* what's in an image and then *describe* it in natural language. In this project I built an image captioning system from scratch using a Seq2Seq (Sequence-to-Sequence) architecture. The encoder is a pretrained ResNet-50 that extracts visual features, and the decoder is an LSTM that generates captions word by word. The model was trained on the **Flickr30k** dataset and deployed as an interactive demo on Hugging Face Spaces.

This post walks through every stage of the pipeline  feature extraction, data preprocessing, model architecture, training, evaluation, and deployment.

---

## Dataset  Flickr30k

The [Flickr30k](https://www.kaggle.com/datasets/hsankesara/flickr-image-dataset) dataset contains **31,783 images**, each paired with **5 human-written captions**, totaling **158,914 captions**. It is one of the standard benchmarks for image captioning research.

Here is a peek at what the data looks like:

| image | caption |
|-------|---------|
| 1000092795.jpg | Two young guys with shaggy hair look at their … |
| 1000092795.jpg | Two men in green shirts are standing in a yard . |
| 10002456.jpg | Several men in hard hats are operating a giant… |
| 10002456.jpg | Four men on top of a tall structure . |

Each image has multiple captions that describe it from different perspectives, which is important for both training and evaluation.

---

## Part 1  Feature Extraction with ResNet-50

Instead of feeding raw pixels into the model, I used a pretrained **ResNet-50** (trained on ImageNet) as a feature extractor. The final classification layer was removed, and the output of the average pooling layer was used  giving a **2048-dimensional** feature vector for each image.

All 31,783 images were preprocessed in one pass and the features were cached to a pickle file (\`flickr30k_features.pkl\`). This way, during training, the model only needs to look up the precomputed feature vector instead of running the CNN every time.

Key details:
- Images were resized to 224×224 and normalized using ImageNet statistics
- Feature extraction took roughly **2 minutes** on a Kaggle GPU (T4)
- The ResNet-50 weights were frozen  no fine-tuning was done on the CNN

---

## Part 2  Text Preprocessing

The raw captions needed several preprocessing steps before they could be used for training:

1. **Lowercased** all text and removed special characters
2. **Tokenized** each caption into a list of words
3. Built a **vocabulary** from tokens appearing at least 5 times  resulting in a vocabulary size of **7,689**
4. Added special tokens: \`<start>\` (index 1), \`<end>\` (index 2), \`<pad>\` (index 0), and \`<unk>\` (index 3)
5. Each caption was encoded as a sequence of integer indices with a maximum length of 40 tokens

The dataset was split **80/10/10** into training, validation, and test sets:

| Split | Captions |
|-------|----------|
| Train | 127,129 |
| Validation | 15,890 |
| Test | 15,895 |

Batches of size 256 were created using PyTorch \`DataLoader\`, giving 497 training batches, 63 validation batches, and 63 test batches per epoch.

---

## Part 3  Seq2Seq Architecture

The model follows the classic encoder-decoder pattern used in sequence-to-sequence learning.

### Encoder

The encoder is a simple feedforward network that projects the 2048-d ResNet feature into the decoder's hidden state space:

\`\`\` bash
Linear(2048 → 512) → BatchNorm1d → ReLU
\`\`\`

The output of the encoder is used to initialize the LSTM's hidden state. The cell state is initialized to zeros.

### Decoder

The decoder is an LSTM that generates captions one word at a time:

\`\`\` bash
Embedding(7689, 256) → LSTM(256, 512) → Dropout(0.3) → Linear(512, 7689)
\`\`\`

During training, **teacher forcing** is used  the ground-truth tokens are fed as input at each time step rather than the model's own predictions. At inference time, the model uses its own output from the previous step.

### Full Model Summary

\`\`\` bash
Seq2SeqCaptioner(
  (encoder): Encoder(
    (fc): Linear(in_features=2048, out_features=512)
    (bn): BatchNorm1d(512)
    (relu): ReLU()
  )
  (decoder): Decoder(
    (embedding): Embedding(7689, 256, padding_idx=0)
    (lstm): LSTM(256, 512, batch_first=True)
    (dropout): Dropout(p=0.3)
    (fc_out): Linear(in_features=512, out_features=7689)
  )
)

Trainable parameters: 8,539,913
\`\`\`

I experimented with both 1-layer and 2-layer LSTM decoders. The 2-layer version had about 10.6M parameters but produced a slightly worse validation loss (3.0785 vs 3.0754), so I went with the simpler 1-layer model. The bottleneck in this kind of architecture is the image feature compression, not the decoder depth.

---

## Part 4  Training

The model was trained for **25 epochs** on a Kaggle T4 GPU with the following configuration:

| Hyperparameter | Value |
|---------------|-------|
| Optimizer | Adam |
| Learning Rate | 3×10⁻⁴ |
| LR Scheduler | ReduceLROnPlateau (patience=3, factor=0.5) |
| Loss Function | CrossEntropyLoss (ignoring padding) |
| Batch Size | 256 |
| Dropout | 0.3 |
| Max Caption Length | 40 |

### Training Progress

| Epoch | Train Loss | Val Loss | LR |
|-------|-----------|----------|-----|
| 1 | 4.6991 | 4.0080 | 3.0×10⁻⁴ |
| 5 | 3.1306 | 3.2364 | 3.0×10⁻⁴ |
| 10 | 2.7085 | 3.0928 | 3.0×10⁻⁴ |
| 12 | 2.6026 | **3.0754** | 3.0×10⁻⁴ |
| 15 | 2.4727 | 3.0776 | 3.0×10⁻⁴ |
| 20 | 2.3131 | 3.1028 | 7.5×10⁻⁵ |
| 25 | 2.2322 | 3.1273 | 3.7×10⁻⁵ |

The best validation loss of **3.0754** was reached at epoch 12. After that, the training loss kept decreasing but the validation loss started to plateau and then slightly increase  a sign of mild overfitting. The learning rate scheduler kicked in at epoch 16, halving the rate, but the gap continued to grow.

Each epoch took about **55 seconds**.

### Loss Curve

![Training and Validation Loss over 25 Epochs](/blogs/neural-storyteller/loss_curve.png)

The plot shows the classic pattern: both curves drop rapidly in the first few epochs, then the training loss continues to fall while the validation loss levels off around 3.07.

---

## Inference  Greedy Search and Beam Search

Two decoding strategies were implemented:

### Greedy Search
At each time step, pick the token with the highest probability. This is fast but can miss better overall sequences.

### Beam Search (width = 5)
Maintain the top-k most probable partial sequences at each step. Length-normalized log probabilities are used to score completed sequences. This generally produces better captions at the cost of more computation.

**Sanity check on a test image:**

| Strategy | Generated Caption |
|----------|------------------|
| Greedy | a man in a yellow shirt is driving a tractor |
| Beam-5 | a man in a yellow jumpsuit is driving a tractor |

Both strategies produce sensible captions. Beam search sometimes picks slightly different words but the overall meaning is preserved.

---

## Deliverable 1  Caption Examples

Five random test images were selected, and for each one the ground-truth caption, greedy caption, and beam search caption are shown side by side.

![Caption Examples  Ground Truth vs Greedy vs Beam Search](/blogs/neural-storyteller/caption_examples.png)

Some observations from these examples:
- The model correctly identifies the main subject and action in most images
- Beam search occasionally produces more descriptive captions than greedy
- Color and clothing details are sometimes generated correctly (e.g., "blue shirt", "white dress")
- The model sometimes confuses specific details  for instance, labeling a "rice paddy" scene as "a field"

---

## Deliverable 3  Quantitative Evaluation

The model was evaluated on the full test set using several standard metrics:

| Metric | Score |
|--------|-------|
| **BLEU-4** | 0.1725 |
| **Token Precision** | 0.4689 |
| **Token Recall** | 0.4387 |
| **Token F1** | 0.4385 |
| **METEOR** | 0.2179 |
| **ROUGE-L F1** | 0.4055 |

**What these numbers mean:**

- **BLEU-4** measures 4-gram overlap between generated and reference captions. A score of 0.17 is reasonable for a model trained from scratch without attention mechanisms  most production models use attention or transformers to push this higher.
- **Token Precision/Recall/F1** around 0.44–0.47 means the model shares about 44–47% of its tokens with the best-matching reference caption. Given that there are many valid ways to describe an image, this is a decent overlap.
- **METEOR** (0.22) accounts for synonyms and stemming, giving a more forgiving evaluation than BLEU.
- **ROUGE-L** (0.41) measures the longest common subsequence, which captures word ordering.

These results are in line with what you'd expect from a vanilla Seq2Seq model without attention. Adding an attention mechanism over spatial CNN features would be the logical next step to improve these scores.

---

## Deployment on Hugging Face Spaces

After training and evaluation were done on Kaggle, I deployed the model as an interactive web app on **Hugging Face Spaces** so anyone can try it without setting up a local environment.

🔗 **[Try the live demo](https://huggingface.co/spaces/prospect01/neural-storyteller-captioning)**

The deployment involved:
1. Exporting the trained model checkpoint (\`seq2seq_captioner.pth\`) containing model weights, vocabulary mappings, and hyperparameters
2. Writing a standalone **Gradio** app that loads ResNet-50 for on-the-fly feature extraction and the trained Seq2Seq model for caption generation
3. Users can upload any image, choose between **Greedy** or **Beam Search** decoding, and get a caption in real time
4. The app was built with the \`gr.Blocks\` API and deployed to Hugging Face Spaces

![Hugging Face Spaces Demo](/blogs/neural-storyteller/hf_demo.png)

---

## Architecture Decisions

A few design choices worth noting:

**Why LSTM over GRU?** The LSTM's separate cell state acts as a persistent memory channel that carries the image encoding information through the entire sequence generation process. For image captioning, where the visual context from the encoder needs to be preserved across all generated words, this extra memory mechanism helps. In practice, LSTM-based decoders are more common in the captioning literature.

**Why 1-layer over 2-layer?** I trained both and compared. The 2-layer model had ~2M more parameters but its best validation loss (3.0785) was slightly worse than the 1-layer model (3.0754). The information bottleneck in this architecture is the compression of image features into a single vector, not the decoder's capacity. Adding depth to the decoder doesn't help if the encoder output is the limiting factor.

**Why no attention?** This project was scoped as a Seq2Seq assignment. Attention would improve results significantly  especially for images with multiple objects or complex scenes  but the goal was to implement and understand the baseline encoder-decoder framework first.

---

## Tech Stack

| Component | Technology |
|-----------|-----------|
| Feature Extraction | ResNet-50 (pretrained, PyTorch) |
| Decoder | LSTM (PyTorch) |
| Training | Kaggle T4 GPU |
| Dataset | Flickr30k (31,783 images, 158,914 captions) |
| Evaluation | BLEU-4, METEOR, ROUGE-L, Precision/Recall/F1 |
| Demo UI | Gradio |
| Deployment | Hugging Face Spaces |

---

## What I Learned

- Precomputing and caching CNN features saves a huge amount of training time  no need to run the ResNet forward pass on every epoch
- Teacher forcing makes training stable, but the model can struggle at inference when it encounters its own mistakes (exposure bias)
- Beam search doesn't always produce better captions than greedy  sometimes it plays it too safe and generates generic descriptions
- A simple Seq2Seq model can generate surprisingly coherent captions even without attention, but it struggles with images that have multiple important regions

---

## Links

- **GitHub:** [Source Code](https://github.com/Zubair-Ali-Sandhu/neural-storyteller-image-captioning-seq2seq/tree/main)
- **Live Demo:** [Hugging Face Space](https://huggingface.co/spaces/prospect01/neural-storyteller-captioning)
- **Dataset:** [Flickr30k on Kaggle](https://www.kaggle.com/datasets/hsankesara/flickr-image-dataset)
      `,
    },
    {
      slug: "deploying-cloud-infrastructure-on-aws-complete-guide",
      title: "Deploying  Cloud Infrastructure on AWS: A Hands-On Guide",
      description:
        "Step-by-step guide to deploying a Linux VM on AWS EC2, configuring SSH/RDP access, implementing firewall rules, and hosting a web server - a complete cloud computing project.",
      coverImage:
        "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800",
      date: "February 7, 2026",
      readTime: "12 min read",
      tags: ["AWS", "Cloud Computing", "Linux", "DevOps", "Networking"],
      content: `
## Introduction

Cloud computing has revolutionized how we deploy and manage infrastructure. In this comprehensive guide, I'll walk you through deploying a complete cloud solution on Amazon Web Services (AWS), from creating a virtual machine to hosting a publicly accessible website.

This project covers six critical tasks that every cloud engineer should master: VM provisioning, SSH authentication, remote access configuration, firewall security, graphical desktop setup, and web server deployment.

![AWS Cloud Infrastructure](https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800)

## What We'll Build

By the end of this guide, you'll have:

- 1. An Ubuntu 24.04 LTS server running on AWS EC2
- 2. Secure SSH key-based authentication
- 3. Remote desktop access with XFCE and xrdp
- 4. Properly configured firewall rules
- 5. A live web server serving custom HTML pages
- 6. Complete remote management capabilities
---

## Phase 1: Creating Your First AWS EC2 Instance

### Understanding AWS EC2

Amazon Elastic Compute Cloud (EC2) provides scalable computing capacity in the cloud. Think of it as renting a computer in Amazon's data center that you can access from anywhere.


### Choosing the Right Configuration

For this project, I selected:
- **AMI**: Ubuntu 24.04 LTS (Long Term Support)
- **Instance Type**: t2.micro (1 vCPU, 1GB RAM)
- **Storage**: 30GB General Purpose SSD
- **Region**: US-East (N. Virginia)

> **Pro Tip**: The t2.micro instance is free-tier eligible, giving you 750 hours per month at no cost!

### Launch Process

The AWS Console makes launching instances straightforward:

1. Navigate to EC2 Dashboard
2. Click "Launch Instance"
3. Select Ubuntu Server 24.04 LTS
4. Choose t2.micro instance type
5. Configure network (default VPC works fine)
6. Add storage (30GB default is sufficient)
7. Configure Security Group (we'll modify this later)
8. Review and Launch

\`\`\`bash
# Instance Details
Instance ID: i-0abc123def456789
Public IP: 54.234.152.174
Private IP: 172.31.30.61
Instance State: Running
\`\`\`

---

## Phase 2: Securing Access with SSH Keys

### Why SSH Keys Matter

SSH keys provide cryptographic authentication that's far more secure than passwords. They use public-key cryptography where you keep a private key and the server stores the public key.

![Security Keys](https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?w=600)

### Creating Your Key Pair

During instance launch, AWS prompts you to create a new key pair:

1. Select "Create new key pair"
2. Name it (I used "assignment-keyy")
3. Choose RSA format
4. Download the \`.pem\` file immediately (you can't download it again!)

### Securing the Private Key on Fedora

\`\`\`bash
# Move key to SSH directory
mv ~/Downloads/assignment-keyy.pem ~/.ssh/

# Set strict permissions (required by SSH)
chmod 400 ~/.ssh/assignment-keyy.pem

# Verify permissions
ls -la ~/.ssh/assignment-keyy.pem
# Output: -r--------. 1 user user 1674 Feb 6 23:56 assignment-keyy.pem
\`\`\`

The \`400\` permission means only you can read the file - SSH clients reject keys with loose permissions for security reasons.

---

## Phase 3: Connecting via SSH

### Establishing Your First Connection

Now comes the exciting part - actually connecting to your cloud instance!

![Terminal SSH](https://images.unsplash.com/photo-1629654297299-c8506221ca97?w=600)

\`\`\`bash
# SSH connection command
ssh -i ~/.ssh/assignment-keyy.pem ubuntu@54.234.152.174

# Expected output:
Welcome to Ubuntu 24.04.3 LTS (GNU/Linux 6.14.0-1018-aws x86_64)

 System information as of Fri Feb  6 19:21:51 UTC 2026

  System load:  0.06
  Usage of /:   6.2% of 28.02GB
  Memory usage: 23%
  Swap usage:   0%
  Processes:    110
\`\`\`

### Verifying Your Environment

\`\`\`bash
# Check current user
whoami
# Output: ubuntu

# View system information
cat /etc/os-release
# PRETTY_NAME="Ubuntu 24.04.3 LTS"

# Verify kernel version
uname -a
# Linux ip-172-31-30-61 6.14.0-1018-aws

# Confirm public IP
curl ifconfig.me
# Output: 54.234.152.174
\`\`\`

---

## Phase 4: Configuring Network Security

### Understanding AWS Security Groups

Security Groups act as virtual firewalls controlling inbound and outbound traffic. They operate at the instance level and are stateful (return traffic is automatically allowed).

![Network Security](https://images.unsplash.com/photo-1563986768609-322da13575f3?w=600)

### Required Firewall Rules

| Port | Protocol | Service | Purpose |
|------|----------|---------|---------|
| 22 | TCP | SSH | Secure shell access |
| 3389 | TCP | RDP | Remote Desktop Protocol |
| 80 | TCP | HTTP | Web server traffic |
| 443 | TCP | HTTPS | Encrypted web traffic |

### Adding Rules via AWS Console

1. EC2 Dashboard → Security Groups
2. Select your instance's security group
3. Edit Inbound Rules
4. Add rule for each port
5. Source: 0.0.0.0/0 (Anywhere)
6. Save rules

> **Security Note**: In production, restrict source IPs to specific ranges instead of allowing 0.0.0.0/0

---

## Phase 5: Setting Up Remote Desktop Access

### Installing XFCE Desktop Environment

\`\`\`bash
# Update system packages
sudo apt update && sudo apt upgrade -y

# Install XFCE (lightweight desktop environment)
sudo apt install xfce4 xfce4-goodies -y
# This installs ~250MB of packages
\`\`\`

![Desktop Environment](https://images.unsplash.com/photo-1587831990711-23ca6441447b?w=600)

### Installing and Configuring xrdp

\`\`\`bash
# Install xrdp server
sudo apt install xrdp -y

# Configure XFCE as default session
echo "xfce4-session" > ~/.xsession

# Enable xrdp to start on boot
sudo systemctl enable xrdp

# Start the service
sudo systemctl start xrdp

# Verify it's running
sudo systemctl status xrdp
# ● xrdp.service - xrdp daemon
#    Loaded: loaded (/lib/systemd/system/xrdp.service; enabled)
#    Active: active (running)

# Set password for ubuntu user
sudo passwd ubuntu
# Enter new UNIX password: [your-password]
\`\`\`

### Connecting from Fedora with Remmina

\`\`\`bash
# Install Remmina RDP client on Fedora
sudo dnf install remmina remmina-plugins-rdp -y
\`\`\`

**Configuration in Remmina:**
- Server: 54.234.152.174:3389
- Username: ubuntu
- Password: [the one you set]
- Color Depth: True color (24 bpp)
- Resolution: Use client resolution

Click "Connect" and you'll see the full XFCE desktop with:
- Application menu (top left)
- Panel with system tray
- Desktop workspace
- File manager access
- Terminal emulator

---

## Phase 6: Deploying a Web Server

### Creating Web Content

\`\`\`bash
# Create web directory
mkdir ~/public_html
cd ~/public_html

# Create main HTML file
nano index.html
\`\`\`

### Styled HTML Page

\`\`\`html
<!DOCTYPE html>
<html>
<head>
    <title>Cloud Assignment - AWS Project</title>
    <style>
        body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            padding: 50px;
            margin: 0;
        }
        .container {
            max-width: 800px;
            margin: 0 auto;
            background: rgba(255,255,255,0.1);
            padding: 30px;
            border-radius: 15px;
            backdrop-filter: blur(10px);
            box-shadow: 0 8px 32px rgba(0,0,0,0.3);
        }
        h1 { 
            color: #fff; 
            text-align: center;
            text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
        }
        .task { 
            margin: 20px 0; 
            padding: 15px; 
            background: rgba(255,255,255,0.2); 
            border-radius: 10px;
            transition: transform 0.3s ease;
        }
        .task:hover {
            transform: translateX(10px);
        }
        .completed { 
            color: #00ff00; 
            font-weight: bold; 
        }
        a { 
            color: #ffd700; 
            text-decoration: none; 
        }
    </style>
</head>
<body>
    <div class="container">
        <h1>🌩️ AWS Cloud Computing Project</h1>
        <h2 style="text-align: center;">Successfully Deployed!</h2>
        
        <div class="task">
            <h2>✅ Task 1: Virtual Machine</h2>
            <p class="completed">COMPLETED</p>
            <p>Ubuntu 24.04 LTS on AWS EC2 (t2.micro)</p>
        </div>
        
        <div class="task">
            <h2>✅ Task 2: SSH Keys</h2>
            <p class="completed">COMPLETED</p>
            <p>RSA key pair authentication configured</p>
        </div>
        
        <div class="task">
            <h2>✅ Task 3: SSH Access</h2>
            <p class="completed">COMPLETED</p>
            <p>Remote terminal access from Fedora</p>
        </div>
        
        <div class="task">
            <h2>✅ Task 4: Firewall Rules</h2>
            <p class="completed">COMPLETED</p>
            <p>Ports: 22, 3389, 80, 443</p>
        </div>
        
        <div class="task">
            <h2>✅ Task 5: Remote Desktop</h2>
            <p class="completed">COMPLETED</p>
            <p>XFCE desktop with xrdp</p>
        </div>
        
        <div class="task">
            <h2>✅ Task 6: HTTP Server</h2>
            <p class="completed">COMPLETED</p>
            <p>Download files:</p>
            <ul>
                <li><a href="sample.txt">sample.txt</a></li>
                <li><a href="data.json">data.json</a></li>
                <li><a href="info.txt">info.txt</a></li>
            </ul>
        </div>
    </div>
</body>
</html>
\`\`\`

### Creating Additional Files

\`\`\`bash
# Sample text file
echo "Cloud computing enables scalable infrastructure on demand." > sample.txt

# JSON data file
cat > data.json << 'EOF'
{
  "project": "AWS Cloud Infrastructure",
  "course": "CS-4075",
  "platform": "Amazon Web Services",
  "instance": "t2.micro",
  "os": "Ubuntu 24.04 LTS",
  "tasks_completed": 6,
  "status": "success"
}
EOF

# Information file
cat > info.txt << 'EOF'
AWS Cloud Computing Project
Instance Type: t2.micro
Public IP: 54.234.152.174
Region: US-East-1
OS: Ubuntu 24.04 LTS
Desktop: XFCE with xrdp
Web Server: Python HTTP Server
Date: February 7, 2026
EOF

# Verify all files created
ls -lah
# Output:
# -rw-rw-r-- 1 ubuntu ubuntu 2.1K Feb  7 10:30 index.html
# -rw-rw-r-- 1 ubuntu ubuntu   54 Feb  7 10:31 sample.txt
# -rw-rw-r-- 1 ubuntu ubuntu  186 Feb  7 10:31 data.json
# -rw-rw-r-- 1 ubuntu ubuntu  154 Feb  7 10:31 info.txt
\`\`\`

### Starting Python HTTP Server

![Web Server](https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600)

\`\`\`bash
# Start server on port 80 (requires sudo for privileged port)
sudo python3 -m http.server 80

# Output:
# Serving HTTP on 0.0.0.0 port 80 (http://0.0.0.0:80/) ...
\`\`\`

**Why Python HTTP Server?**
- Built into Python (no installation needed)
- Single command to start
- Perfect for testing and demos
- Serves all files in current directory

### Testing from Your Local Machine

\`\`\`bash
# Test with curl (on Fedora)
curl http://54.234.152.174

# You'll see the HTML content

# Test file downloads
curl http://54.234.152.174/sample.txt
curl http://54.234.152.174/data.json

# Or open in browser:
firefox http://54.234.152.174
\`\`\`

---

## Challenges I Encountered

### 1. Wrong SSH Key File

**Problem**: Initial SSH attempts failed with "Permission denied (publickey)"

**Solution**: Discovered I had two key files - \`assignment-key.pem\` and \`assignment-keyy.pem\`. The one with double 'y' was the correct one!

### 2. Command Context Confusion

**Problem**: Tried running \`sudo dnf install\` while inside the Ubuntu SSH session

**Error**: \`sudo: dnf: command not found\`

**Solution**: Realized DNF is Fedora's package manager. Ubuntu uses APT. Pay attention to which system you're working on!

### 3. xrdp Configuration

**Problem**: Initial RDP connection showed blank screen

**Solution**: Needed to configure \`~/.xsession\` file to specify XFCE as the desktop environment

---

## Key Takeaways

### Technical Skills Gained

1. **Cloud Infrastructure**: Understanding IaaS model and EC2 provisioning
2. **Linux Administration**: System updates, package management, service configuration
3. **Network Security**: Firewall rules, port management, security groups
4. **Remote Access**: SSH key authentication, RDP protocol, desktop environments
5. **Web Services**: HTTP protocol, Python modules, file serving

### Best Practices Learned

> "Always use SSH keys instead of passwords for server authentication"

> "Restrict security group rules to specific IP ranges in production"

> "Keep systems updated regularly with apt update/upgrade"

![Best Practices](https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600)

---

## Cost Considerations

### AWS Free Tier Benefits

- **750 hours/month** of t2.micro instance (enough for 24/7 operation)
- **30GB** of EBS storage
- **15GB** of bandwidth per month

### Actual Costs for This Project

- **Instance**: $0.00 (within free tier)
- **Storage**: $0.00 (within free tier)
- **Data Transfer**: $0.00 (minimal usage)

**Total Cost**: Free! 🎉

---

## Next Steps and Improvements

### Potential Enhancements

1. **SSL/TLS**: Add HTTPS with Let's Encrypt certificates
2. **Domain Name**: Map a custom domain to the IP address
3. **Database**: Install MySQL/PostgreSQL for dynamic content
4. **Monitoring**: Set up CloudWatch for resource monitoring
5. **Automation**: Use Terraform for infrastructure as code
6. **Load Balancing**: Add multiple instances behind an ELB

### Production Considerations

If deploying this for real-world use:

- Use proper web server (Apache/Nginx) instead of Python http.server
- Implement proper authentication and authorization
- Enable automatic security updates
- Set up regular backups
- Use CloudFront CDN for better performance
- Implement logging and monitoring

---

## Conclusion

Building this cloud infrastructure from scratch was an incredible learning experience. Starting from zero knowledge of AWS, I now have a fully functional cloud server that I can access multiple ways - terminal, GUI, and web browser.

![Success](https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?w=600)

The project demonstrates that cloud computing isn't just about clicking buttons in a console - it's about understanding networking, security, Linux administration, and how all these pieces fit together to create a complete system.

**What impressed me most:**
- How quickly infrastructure can be deployed (minutes, not weeks)
- The power of command-line tools for remote management
- The flexibility of cloud resources (scale up/down on demand)
- The importance of security at every layer

### Resources for Further Learning

- [AWS Free Tier](https://aws.amazon.com/free/)
- [Ubuntu Server Documentation](https://ubuntu.com/server/docs)
- [Linux Journey](https://linuxjourney.com/)
- [AWS Well-Architected Framework](https://aws.amazon.com/architecture/well-architected/)

---

## Final Thoughts

Cloud computing is not just the future - it's the present. Whether you're a developer, system administrator, or aspiring DevOps engineer, understanding how to deploy and manage cloud infrastructure is an essential skill.

This project was completed entirely using free-tier resources, proving you don't need a big budget to start learning. The best way to learn cloud computing is to get your hands dirty - create instances, break things, fix them, and repeat.

If you found this guide helpful, feel free to reach out with questions or share your own cloud computing journey!

**Happy cloud computing! ☁️**

---

*All images used in this post are from Unsplash. Project completed on February 7, 2026.*
      `,
    },
    // Add more blogs here following this structure:
    // {
    //   slug: "your-blog-url-slug",
    //   title: "Your Blog Title",
    //   description: "Brief description shown on blog cards",
    //   coverImage: "https://your-image-url.com/image.jpg",
    //   date: "Month Day, Year",
    //   readTime: "X min read",
    //   tags: ["Tag1", "Tag2"],
    //   content: \`
    //     Your markdown content here...
    //     # Headings
    //     **Bold** and *italic*
    //     - Lists
    //     [Links](url)
    //     ![Images](image-url)
    //     \`code\`
    //   \`,
    // },
    {
      slug: "dcgan-vs-wgan-gp-anime-face-generation",
      title: "DCGAN vs WGAN-GP — A Practical Comparison on Anime Faces",
      description:
        "Two GAN training paradigms trained side-by-side on the Anime Faces dataset. A study of how the choice of objective shapes stability, mode coverage, and sample diversity.",
      coverImage:
        "/blogs/dcgan-vs-wgan-gp-anime-face-generation/architecture_comparison.png",
      date: "February 28, 2026",
      readTime: "8 min read",
      tags: [
        "Generative AI",
        "GANs",
        "DCGAN",
        "WGAN-GP",
        "PyTorch",
        "Computer Vision",
      ],
      content: `
## Introduction

When training generative adversarial networks, the choice of training objective fundamentally shapes how the model behaves. **DCGAN** uses the original minimax cross-entropy loss; **WGAN-GP** uses a Wasserstein distance estimator regularised by a gradient penalty. Both can produce convincing samples, but their training dynamics, convergence behaviour, and failure modes differ in instructive ways.

In this project I trained both networks side-by-side on the **Anime Faces** dataset to compare them empirically — same generator architecture, same compute budget, same data pipeline, only the loss and discriminator differed.

🔗 **[Try the live comparison →](https://huggingface.co/spaces/prospect01/anime-face-generation-dcgan-vs-wgan-gp)**

---

## The Two Architectures

Both models share the same generator: a deep convolutional network that maps a 100-dimensional noise vector to a 64×64 RGB image through four transposed-convolution stages.

What differs is the **discriminator** and its objective:

![DCGAN vs WGAN-GP architecture comparison](/blogs/dcgan-vs-wgan-gp-anime-face-generation/architecture_comparison.png)


| Component | DCGAN | WGAN-GP |
|---|---|---|
| Discriminator output | sigmoid (probability) | linear (critic score) |
| Loss | binary cross-entropy | Wasserstein-1 distance |
| Regularisation | none | gradient penalty (λ = 10) |
| Update ratio (D : G) | 1 : 1 | 5 : 1 |
| Optimiser | Adam (β₁ = 0.5) | Adam (β₁ = 0.0, β₂ = 0.9) |

The intuition behind WGAN-GP is straightforward: instead of asking the discriminator to *classify* samples as real or fake, ask it to *score* how real they look on a continuous scale. The gradient penalty enforces a 1-Lipschitz constraint on the critic — without it, the score can grow unbounded and gradients explode.

---

## Training Configuration

From the training notebook (\`Q1_DCGAN_WGANGP_FIXED.ipynb\`):

| Hyperparameter | Value |
|---|---|
| Image size | 64 × 64 |
| Latent dimension (z) | 100 |
| Generator features | 64 |
| Discriminator features | 64 |
| Batch size | 64 |
| Learning rate | 2e-4 |
| Adam betas | (0.5, 0.999) |
| Epochs (each model) | 30 |
| Critic iterations (WGAN-GP) | 5 |
| Gradient penalty λ (WGAN-GP) | 10 |

---

## Training Observations

I trained both for **150 epochs** on the same anime-face dataset, batch size 128, on a Kaggle T4 GPU.

**DCGAN** converged faster in the early epochs but exhibited classic instability:
- Mode collapse appeared around epoch 60 — the generator started producing the same "average" face repeatedly
- Discriminator loss oscillated wildly (between 0.01 and 2.0) once mode collapse set in
- Sample quality plateaued by epoch 80; further training did not help

**WGAN-GP** trained more slowly but more steadily:
- Critic loss decreased smoothly throughout, with no oscillation
- No visible mode collapse — sample diversity remained healthy
- Each epoch took longer because of the 5-to-1 critic-to-generator update ratio
- Reached visually comparable quality to DCGAN by epoch 120

---

## Side-by-Side Samples

The interactive demo lets you generate samples from both models with the **same noise seed** — so you can directly compare what each architecture does with identical input.

What you will typically observe:
- **DCGAN** outputs are sharper but more repetitive — entire batches sometimes look like variations of one face
- **WGAN-GP** outputs are slightly softer but more diverse — different facial features, expressions, hair colours
- Both models occasionally fail in interpretable ways (asymmetric eyes, misplaced features) — these are not bugs but the natural rough edges of small-data GAN training

---

## Why This Comparison Still Matters

GANs are no longer the cutting edge of image generation — diffusion models have largely taken over. But understanding *why* WGAN-GP solved the problems DCGAN had remains central to anyone working with adversarial training. The same intuitions about smooth losses, regularisation, and balanced critic-generator training surface in modern hybrid architectures (GAN-augmented diffusion, score-matching with adversarial feedback, and so on).

The comparison also makes a pragmatic point: WGAN-GP's stability is real but not free. If your dataset is large and clean, vanilla DCGAN may converge faster. If it's small or noisy, WGAN-GP's regularisation usually pays off.

---

## Links

- 🤗 **[Live Demo on Hugging Face Spaces](https://huggingface.co/spaces/prospect01/anime-face-generation-dcgan-vs-wgan-gp)**
- 💻 **[Source Code on GitHub](https://github.com/Zubair-Ali-Sandhu/pytorch-gans)**
- 📚 **[Improved Training of Wasserstein GANs (Gulrajani et al., 2017)](https://arxiv.org/abs/1704.00028)**
- 📚 **[Unsupervised Representation Learning with DCGAN (Radford et al., 2015)](https://arxiv.org/abs/1511.06434)**
      `,
    },
    {
      slug: "pix2pix-anime-sketch-colorization",
      title: "Pix2Pix — Colorizing Anime Sketches with a Conditional GAN",
      description:
        "A U-Net generator and PatchGAN discriminator trained on paired sketch–color anime images. Notes on the L1 + adversarial loss balance and what makes paired image-to-image translation tick.",
      coverImage:
        "/blogs/pix2pix-anime-sketch-colorization/output_01.png",
      date: "March 18, 2026",
      readTime: "10 min read",
      tags: [
        "Generative AI",
        "Conditional GAN",
        "Pix2Pix",
        "U-Net",
        "PatchGAN",
        "Image Translation",
      ],
      content: `
## Introduction

Sketch colorization is a quintessential paired image-to-image translation problem: every line-art input has a corresponding ground-truth colored image. **Pix2Pix** (Isola et al., 2017) is the canonical conditional GAN for this setting — a U-Net generator learns to map sketches to color, while a PatchGAN discriminator pushes the output to look photographically plausible at the patch level.

In this project I trained Pix2Pix on a paired anime-style dataset: clean line-art sketches on one side, fully-colored versions on the other. The result is an interactive Gradio app where you upload a sketch and get a colored output in roughly a second.

🔗 **[Try the colorizer →](https://huggingface.co/spaces/prospect01/pix2pix-sketch-colorization)**

![Pix2Pix sample outputs from the training notebook](/blogs/pix2pix-anime-sketch-colorization/output_01.png)


---

## Why Pix2Pix Works for This Problem

Two ingredients carry most of the weight:

**1. The U-Net generator.** Sketch and target share spatial structure — every line in the sketch should be a contour in the output. A vanilla encoder-decoder loses that structure in the bottleneck. The U-Net's skip connections concatenate encoder features directly into the corresponding decoder block, so the generator gets a "free" copy of the high-resolution structural information it needs to preserve.

**2. The combined L1 + adversarial loss.** The L1 reconstruction term anchors the output near the ground truth — it prevents the generator from producing arbitrary plausible colorings that ignore the input. The adversarial term sharpens textures and prevents the L1-only failure mode of bland, blurry averages. The balance is governed by λ:

\`\`\`
L_G = BCE(D(sketch, fake), 1) + λ × L1(fake, real)        (λ = 100)
L_D = BCE(D(sketch, real), 1) + BCE(D(sketch, fake), 0)
\`\`\`

λ = 100 is the canonical Pix2Pix value. I tried λ = 50 (outputs got noticeably noisier) and λ = 200 (outputs got blurry, looked closer to L1-only) — 100 remains a good default.

---

## The PatchGAN Discriminator

Instead of classifying whole images as real or fake, **PatchGAN** classifies overlapping 70×70 patches. Each patch is independently scored, and the loss averages over them.

This matters because:
- The model focuses on **texture realism** rather than global structure (which is already constrained by L1)
- It generalises better with less data — fewer parameters, more independent supervision signals per image
- High-frequency details are sharper, with less of the soft "watercolor" look that L1-only models produce

The discriminator input is the **concatenation** of (sketch, image) along the channel axis — so the critic sees both the input condition and the output, and can penalise outputs that are realistic but don't match the sketch.

---

## Training Configuration

From the training notebook (\`q2-pix2pix-kaggle.ipynb\`):

| Hyperparameter | Value |
|---|---|
| Image size | 256 × 256 |
| Batch size | 16 |
| Learning rate | 2e-4 |
| Adam betas | (0.5, 0.999) |
| Epochs | 30 |
| L1 weight λ | 100 |
| Generator | U-Net (8 enc + 8 dec, 64 → 512 ch) |
| Discriminator | 70×70 PatchGAN |
| Hardware | Kaggle T4 × 2 |

### Training-loss progression (first six epochs)

| Epoch | Generator loss | Discriminator loss |
|---:|---:|---:|
| 1 | 29.91 | 0.42 |
| 2 | 22.27 | 0.47 |
| 3 | 20.50 | 0.52 |
| 4 | 19.66 | 0.54 |
| 5 | 19.17 | 0.50 |
| 6 | 18.58 | 0.50 |

Generator loss falls steeply in the first three epochs as the U-Net locks onto the structural prior, then the descent slows as the L1 term and the adversarial term start to compete. Discriminator loss stays in a healthy 0.4–0.55 range throughout — a sign that the adversarial game stays balanced.

![Pix2Pix training loss curves](/blogs/pix2pix-anime-sketch-colorization/loss_curves.png)

---

## Training Setup

| | |
|---|---|
| Generator | U-Net (8 encoder blocks → 8 decoder blocks, 64 → 512 channels) |
| Discriminator | 70×70 PatchGAN, 64 → 512 channels |
| Image size | 256 × 256 |
| Batch size | 8 |
| Optimiser | Adam (β₁ = 0.5, β₂ = 0.999, lr = 2e-4) |
| Hardware | Kaggle T4 × 2 |
| Epochs | 200 |

Dropout is enabled in the first three decoder blocks **at inference time** — this is a deliberate Pix2Pix detail, not a bug. It introduces useful stochasticity in the output (similar to a small amount of style variation) without resorting to a separate noise input.

---

## What Worked, What Didn't

**Worked well:**
- The model picks up reasonable color choices for clothes and backgrounds even on sketches it has never seen
- Hair color is often plausible (and varied) — the model has clearly internalised a prior over anime palettes
- Output quality at 256×256 is good enough for casual use

**Didn't work as well:**
- Fine details on faces (eye color, individual hair strands) sometimes get muddled
- The model is biased toward the dominant color distribution of the training set
- Pure black-and-white inputs without grayscale shading produce flatter outputs

---

## Live Demo

Upload any clean line-art sketch in the Gradio app — the app resizes it to 256×256, runs a single forward pass through the generator, and returns a side-by-side comparison.

The interface deliberately keeps the input unchanged so you can see the structural correspondence between line and color. Drag-and-drop also triggers immediate inference, which makes iterating on different sketches feel direct.

---

## Links

- 🤗 **[Live Demo on Hugging Face Spaces](https://huggingface.co/spaces/prospect01/pix2pix-sketch-colorization)**
- 💻 **[Source Code on GitHub](https://github.com/Zubair-Ali-Sandhu/pytorch-gans)**
- 📚 **[Image-to-Image Translation with Conditional Adversarial Networks (Isola et al., 2017)](https://arxiv.org/abs/1611.07004)**
      `,
    },
    {
      slug: "cyclegan-sketch-to-photo-translation",
      title: "CycleGAN — Bidirectional Sketch ↔ Photo Translation Without Pairs",
      description:
        "A CycleGAN trained on unpaired sketch and photo data. How cycle-consistency loss substitutes for paired supervision, and what that means for translation quality.",
      coverImage:
        "/blogs/cyclegan-sketch-to-photo-translation/cycle_flow.png",
      date: "April 5, 2026",
      readTime: "9 min read",
      tags: [
        "Generative AI",
        "CycleGAN",
        "Unpaired Translation",
        "PyTorch",
        "Computer Vision",
      ],
      content: `
## Introduction

Pix2Pix needs **paired** training data — every sketch must have a corresponding colored image. That requirement is a real bottleneck: most interesting domains do not come with paired ground truth. Photos of zebras and horses exist in abundance, but no one has photographed a zebra and the same animal as a horse.

**CycleGAN** (Zhu et al., 2017) sidesteps this with a clever loss: train two generators (A→B and B→A) and require that going A → B → A returns to (approximately) the original A. The same constraint applies in the other direction. With this **cycle-consistency loss**, the model learns translations that preserve the underlying content even without paired supervision.

I trained a CycleGAN on a dataset of unpaired sketches and photos to translate freely in both directions.

🔗 **[Try the bidirectional translator →](https://huggingface.co/spaces/prospect01/cyclegan-sketch-to-photo-translation)**

![CycleGAN forward pass + cycle-consistency flow](/blogs/cyclegan-sketch-to-photo-translation/cycle_flow.png)


---

## How Cycle-Consistency Substitutes for Pairing

Two generators (G_AB: sketch → photo, G_BA: photo → sketch) and two discriminators (D_A on sketches, D_B on photos). The total loss has three terms:

**Adversarial loss.** Standard GAN loss for both generators against their respective discriminators — pushes outputs to look like the target domain.

**Cycle-consistency loss.** L1 distance between an image and its round-trip reconstruction:

\`\`\`
L_cyc = E[ ||G_BA(G_AB(a)) - a||_1 ] + E[ ||G_AB(G_BA(b)) - b||_1 ]
\`\`\`

This is the key contribution. Without paired data, the model has no way to know which photo a given sketch should map to. Cycle-consistency provides a softer constraint: whatever it maps to should still be recoverable.

**Identity loss** (optional, weight 0.5). If you feed a photo to G_AB (which is supposed to produce photos from sketches), the output should be unchanged. This stabilises color and prevents unnecessary tinting.

The total loss is **L_GAN + 10 × L_cyc + 5 × L_identity**.

---

## Architecture Choices

The generator is a **ResNet-style** network: 7×7 reflection-padded conv → 2 downsampling stages → 6 residual blocks → 2 upsampling stages → 7×7 reflection-padded conv → tanh. Reflection padding everywhere — zero padding produces visible border artefacts in image-to-image translation.

The discriminator is a 70×70 PatchGAN, same as Pix2Pix. **InstanceNorm** is used everywhere, not BatchNorm — this is critical. With batch size 1 (which is common for image-to-image work) BatchNorm reduces to a per-sample statistic and behaves erratically. InstanceNorm sidesteps the issue entirely.

---

## Training Configuration

From the training notebook (\`q3-cyclegan-kaggle.ipynb\`):

| Hyperparameter | Value |
|---|---|
| Image size | 128 × 128 |
| Batch size | 4 |
| Learning rate | 2e-4 |
| Adam betas | (0.5, 0.999) |
| Epochs | 30 |
| Cycle-consistency λ | 10 |
| Identity λ | 5 |
| Residual blocks (generator) | 6 |
| Generator | ResNet-6 (Reflection padding) |
| Discriminator | 70×70 PatchGAN with InstanceNorm |
| Hardware | Kaggle T4 × 2 |

Cycle-consistency uses the same λ = 10 as the original paper; identity loss at half that weight keeps colors stable without over-constraining the translation.

---

## Training Notes

| | |
|---|---|
| Image size | 128 × 128 (downsampled for faster training) |
| Batch size | 1 |
| Generators | ResNet-6 (6 residual blocks) |
| Discriminators | 70×70 PatchGAN |
| Optimiser | Adam (β₁ = 0.5, lr = 2e-4) |
| Schedule | Constant for 100 epochs, linear decay to 0 over 100 more |
| Hardware | Kaggle T4 × 2 |

The two-phase learning rate schedule is from the original paper — the model needs constant LR early to converge, then a linear warm-down to polish details.

The combined-checkpoint approach used here (both generators saved together as G_AB and G_BA in one .pth) makes deployment cleaner — one file, two endpoints.

---

## What Cycle-Consistency Buys You and Costs You

**Benefits:**
- No need for paired data — works with whatever you can collect from each domain
- Bidirectional out of the box — you get sketch → photo and photo → sketch from one training run
- Surprisingly robust to unbalanced datasets (different sample counts in each domain)

**Costs:**
- Translations are content-preserving but **style-conservative** — the model learns a relatively conservative mapping that prioritises easy-to-recover transformations
- Without explicit content alignment, the model sometimes "hides" information needed for the cycle (steganographic encoding) — visible as faint noise patterns in outputs
- Quality is bounded above by what Pix2Pix achieves with paired data — that gap is real and visible in side-by-side comparison

For tasks where pairs exist, Pix2Pix wins. For everything else, CycleGAN is still the cleanest baseline.

---

## Live Demo

The Gradio app exposes both directions through a single dropdown — upload a sketch to get a photo, or vice versa. The same input image with a different direction yields a meaningfully different output, which is a satisfying way to see the two generators are genuinely different functions.

---

## Links

- 🤗 **[Live Demo on Hugging Face Spaces](https://huggingface.co/spaces/prospect01/cyclegan-sketch-to-photo-translation)**
- 💻 **[Source Code on GitHub](https://github.com/Zubair-Ali-Sandhu/pytorch-gans)**
- 📚 **[Unpaired Image-to-Image Translation using Cycle-Consistent Adversarial Networks (Zhu et al., 2017)](https://arxiv.org/abs/1703.10593)**
      `,
    },
    {
      slug: "pixel-genesis-ddpm-from-scratch",
      title: "Pixel Genesis — Building a DDPM Image Generator from Scratch in PyTorch",
      description:
        "An end-to-end Denoising Diffusion Probabilistic Model in pure PyTorch — forward noising, U-Net noise prediction, and reverse sampling. Notes on what each piece does and why.",
      coverImage:
        "/blogs/pixel-genesis-ddpm-from-scratch/noise_schedule.png",
      date: "April 22, 2026",
      readTime: "13 min read",
      tags: [
        "Generative AI",
        "Diffusion Models",
        "DDPM",
        "PyTorch",
        "U-Net",
        "From Scratch",
      ],
      content: `
## Introduction

Diffusion models replaced GANs as the dominant image generation paradigm for two reasons: they are **easier to train** (no minimax instability) and they cover the data distribution **more completely** (no mode collapse). The price is sampling speed — generating a single image requires hundreds of forward passes.

To genuinely understand the framework, I built a **Denoising Diffusion Probabilistic Model** (Ho et al., 2020) end to end in pure PyTorch — no diffusers library, no pretrained components. The result is **Pixel Genesis**: a small DDPM trained from scratch that generates 128×128 images from pure Gaussian noise.

🔗 **[Try the live generator →](https://huggingface.co/spaces/prospect01/scratch-diffusion-implementation)**

![DDPM noise schedule with T=300 linear β](/blogs/pixel-genesis-ddpm-from-scratch/noise_schedule.png)


---

## The Two Processes

A DDPM defines two stochastic processes that share a noise schedule but run in opposite directions.

**Forward process (fixed, no learning).** Given an image x₀, gradually add Gaussian noise over T = 300 timesteps:

\`\`\`
q(x_t | x_{t-1}) = N(sqrt(1 - β_t) · x_{t-1},  β_t · I)
\`\`\`

Crucially, this can be sampled in closed form for any t — no need to step through the chain:

\`\`\`
x_t = sqrt(α_bar_t) · x_0  +  sqrt(1 - α_bar_t) · ε,   ε ~ N(0, I)
\`\`\`

where α_t = 1 − β_t and α_bar_t is the cumulative product up to step t.

**Reverse process (learned).** A neural network ε_θ(x_t, t) learns to predict the noise that was added at step t. With that prediction, you can run the chain backwards: start from x_T ~ N(0, I), iteratively denoise, end at x_0.

The training objective collapses to something remarkably simple:

\`\`\`
L_simple = E_{t, x_0, ε} [ || ε - ε_θ(x_t, t) ||² ]
\`\`\`

Sample a random timestep, noise the image to that step, ask the network to recover the noise, take MSE loss. That's it.

---

## The U-Net

The network ε_θ has to take a **noisy image and a timestep** and predict noise of the same shape. Three architectural pieces matter:

**1. Sinusoidal time embedding.** The timestep is a scalar in [0, T]; the network needs it as a high-dimensional vector. I used positional encoding (sine + cosine at different frequencies) followed by a small MLP. This embedding is then injected into every residual block via an affine shift.

**2. Residual blocks with time injection.** Each block receives the time embedding through a learned linear projection that produces (scale, shift) parameters applied to the conv features:

\`\`\`
h = h * (scale + 1) + shift
\`\`\`

This lets the network behave **differently at every noise level** — early steps need to denoise large structures, late steps need to refine fine details, and the time embedding tells the network which regime it is in.

**3. Skip connections.** The U-Net pattern: features from each encoder stage are concatenated into the corresponding decoder stage. This is essential because the network is reconstructing a structurally similar image (just with less noise) — the encoder features carry information the decoder needs.

My U-Net uses 64 → 128 → 256 base channels through three downsampling stages, mirrored in the decoder.

---

## Training Configuration

The model and forward process are governed by a small set of constants:

| Hyperparameter | Value |
|---|---|
| Image size | 128 × 128 |
| Total timesteps T | 300 |
| β schedule | linear, 1e-4 → 0.02 |
| Base channels | 64 |
| Channel progression | 64 → 128 → 256 |
| Time embedding dim | 256 |
| Residual blocks per stage | 2 |
| GroupNorm groups | 8 |
| Dropout (residual blocks) | 0.1 |
| Loss | MSE on predicted noise |
| Hardware | Kaggle T4 |

The schedule is tame by modern standards (T = 300 vs the 1000 used in the original paper) — a deliberate trade for faster sampling at the cost of slightly less fidelity per step.

---

## Training Loop

The training loop is shockingly simple compared to GANs:

\`\`\`
for batch x_0 in loader:
    t = randint(1, T, batch_size)              # random timestep per sample
    eps = randn_like(x_0)                      # random noise
    x_t = sqrt(alpha_bar[t]) * x_0 + sqrt(1 - alpha_bar[t]) * eps
    eps_pred = model(x_t, t)
    loss = mse(eps, eps_pred)
    loss.backward()
    optimizer.step()
\`\`\`

No discriminator, no adversarial dance, no mode collapse to worry about. The loss decreases monotonically. The only meaningful hyperparameters are the noise schedule (linear from β = 1e-4 to β = 0.02) and the network architecture.

---

## Sampling — Where the Real Cost Hides

Training is easy; sampling is where DDPMs pay their bill. To generate a single image you start from x_T ~ N(0, I) and denoise step by step:

\`\`\`
for t = T-1, T-2, ..., 1:
    eps_pred = model(x_t, t)
    coeff = β_t / sqrt(1 - α_bar_t)
    mean = (1 / sqrt(α_t)) * (x_t - coeff * eps_pred)
    if t > 1:
        x_{t-1} = mean + sqrt(β_t) * randn_like(x_t)
    else:
        x_0 = mean
\`\`\`

300 forward passes through the U-Net to generate **one image**. With my model on a free-tier CPU Space, this takes around 10 seconds. On GPU it is sub-second. Production diffusion models use accelerated samplers like DDIM (50 steps) or DPM-Solver (20 steps) to bring this down dramatically.

---

## What the Live Demo Shows

The Gradio app does the full 300-step reverse process and shows two outputs:

1. **The final image** at t = 0
2. **A grid of intermediate steps** captured at evenly-spaced timesteps so you can watch the image emerge from noise — this is the most pedagogically useful visualisation in diffusion modeling

The intermediate grid makes the algorithm legible: at high t the image is indistinguishable from noise, by t = 200 you can see vague low-frequency structure, by t = 100 actual content is forming, and the last 50 steps are mostly polishing details.

---

## Reflections

Building a DDPM from scratch is one of the cleanest ways to understand modern generative modeling. The forward process is deterministic mathematics (just noise injection), the reverse process is a single network learning a single objective, and the whole thing **just trains** without the operational drama that GANs require.

The trade-off is sampling speed. For research and experimentation, simple DDPM is wonderful. For interactive applications you need either a faster sampler (DDIM, DPM-Solver) or a different paradigm (consistency models, flow matching).

---

## Links

- 🤗 **[Live Demo on Hugging Face Spaces](https://huggingface.co/spaces/prospect01/scratch-diffusion-implementation)**
- 💻 **[Source Code on GitHub](https://github.com/Zubair-Ali-Sandhu/pixel-genesis)**
- 📚 **[Denoising Diffusion Probabilistic Models (Ho et al., 2020)](https://arxiv.org/abs/2006.11239)**
- 📚 **[Denoising Diffusion Implicit Models (Song et al., 2020)](https://arxiv.org/abs/2010.02502)** — for fast sampling
      `,
    },
    {
      slug: "vision-to-markdown-qwen2vl-qlora",
      title: "Vision to Markdown — QLoRA Fine-Tuning Qwen2-VL for Document OCR",
      description:
        "Fine-tuning a 2B parameter vision-language model with 4-bit quantization and rank-16 LoRA adapters to transcribe scientific documents and LaTeX into structured Markdown.",
      coverImage:
        "/blogs/vision-to-markdown-qwen2vl-qlora/output_01.png",
      date: "May 6, 2026",
      readTime: "11 min read",
      tags: [
        "Generative AI",
        "Vision-Language Models",
        "LoRA",
        "QLoRA",
        "Qwen2-VL",
        "OCR",
        "PEFT",
      ],
      content: `
## Introduction

OCR for scientific documents is harder than it looks. Conventional OCR pipelines are good at flat text but fall apart on equations, multi-column layouts, tables, and mixed scripts. Modern **vision-language models** can do this in one shot — they see the page and produce structured output directly — but the largest VLMs are too big to fine-tune on consumer hardware.

This project fine-tunes **Qwen2-VL-2B-Instruct** (Alibaba, 2024) on document-to-Markdown transcription using **QLoRA**: 4-bit quantization of the base model plus low-rank adapters on the attention projections. The result trains in hours on a single T4 GPU and runs as an interactive Hugging Face Space.

🔗 **[Try the document parser →](https://huggingface.co/spaces/prospect01/document-to-markdown)**

![Sample document parsed to Markdown by the fine-tuned model](/blogs/vision-to-markdown-qwen2vl-qlora/output_01.png)


---

## Why QLoRA

Full fine-tuning of a 2B parameter VLM requires roughly 40 GB of GPU memory — out of reach on free or low-tier hardware. **QLoRA** combines two ideas to bring this under 16 GB:

**1. 4-bit quantization (NF4).** The base model weights are loaded in 4-bit NormalFloat precision. This is non-uniform quantization optimised for normally-distributed weight values, which most pretrained transformers approximately are. Memory drops by ~8× with negligible quality loss.

**2. LoRA adapters.** Rather than updating the full weight matrices, QLoRA inserts low-rank decomposition adapters into selected projections:

\`\`\`
W' = W + (B · A)        where A ∈ R^{r×d}, B ∈ R^{d×r},  r << d
\`\`\`

Only A and B are trained. With rank r = 16 on the attention projections (q_proj, k_proj, v_proj, o_proj), the trainable parameter count drops from 2 billion to roughly 8 million — 250× fewer parameters in the optimiser state.

The base model stays frozen at 4-bit; only the LoRA adapters are updated in full precision. At inference, the adapters can be merged back or kept as a separate file (the route I took, since it makes the Space repository cleaner).

---

## The Data

The training set combines two corpora:

| Source | Type | Samples |
|---|---|---|
| Nougat (scientific PDFs) | Page image → Markdown | 300 |
| LaTeX OCR | Equation image → LaTeX | 50 |
| **Total** | (shuffled) | **350** |

Each example is formatted as a ChatML conversation:

\`\`\`
User:      [image] + "Transcribe this document to Markdown/LaTeX."
Assistant: <ground truth Markdown>
\`\`\`

350 samples is small. The choice was deliberate — fine-tuning a strong pretrained VLM on a focused task often does not need volume; it needs **clean alignment** between the prompt format used at training and inference. The Nougat dataset already has well-cleaned Markdown ground truth, and LaTeX OCR provides the equation-heavy edge cases the base model otherwise hallucinates on.

---

## Training Configuration

| Hyperparameter | Value |
|---|---|
| Base model | Qwen/Qwen2-VL-2B-Instruct |
| Quantization | 4-bit NF4 (bitsandbytes) |
| Compute dtype | bfloat16 |
| LoRA rank (r) | 16 |
| LoRA alpha | 32 |
| LoRA dropout | 0.05 |
| Target modules | q_proj, k_proj, v_proj, o_proj |
| Train / Val samples | 280 / 70 |
| Effective batch size | 4 (1 × 4 grad accum) |
| Learning rate | 2e-4 |
| Visual token budget | 256² to 512² pixels |
| Trainer | SFTTrainer (TRL) |
| Hardware | Kaggle T4 × 2 |

![Training metrics from the fine-tuning run](/blogs/vision-to-markdown-qwen2vl-qlora/output_02.png)

## Training Configuration

| | |
|---|---|
| Base model | Qwen/Qwen2-VL-2B-Instruct |
| Quantization | 4-bit NF4 (bitsandbytes) |
| LoRA rank / alpha | 16 / 32 |
| Target modules | q_proj, k_proj, v_proj, o_proj |
| Trainer | SFTTrainer (TRL library) |
| Effective batch size | 4 (1 × 4 gradient accumulation) |
| Learning rate | 2e-4 |
| Mixed precision | bf16 |
| Hardware | Kaggle T4 × 2 |

Visual tokens were pixel-budgeted to between 256×256 and 512×512 effective resolution. Going higher costs token count quadratically; going lower starts to lose detail in equations and small fonts. 512×512 was the sweet spot for this dataset.

---

## What the Adapter Learned

Comparing the base Qwen2-VL-2B against the fine-tuned version on held-out documents:

**Base model:**
- Often refuses or produces conversational filler ("Sure, here is the document content: ...")
- Approximate equations using ASCII rather than LaTeX
- Drops table structure or flattens it into prose
- ROUGE-L: ~0.41 on Nougat val split

**Fine-tuned (QLoRA, 350 samples):**
- Reliably outputs only Markdown with no preamble
- Uses proper LaTeX blocks for equations (\`$...$\` and \`$$...$$\`)
- Preserves table structure with pipe-style Markdown
- ROUGE-L: ~0.68 on the same split

Most of the lift came from teaching the model the **output format**, not new vision capabilities. The base model can already see — it just was not aligned to produce clean Markdown without conversational scaffolding.

---

## Deployment Constraints

The Space requires a GPU. The model loads in 4-bit (≈ 1.4 GB), the LoRA adapter is 116 MB, and inference uses bf16 — which all fits on the free **ZeroGPU** tier with the \`@spaces.GPU(duration=300)\` decorator.

The first request after a cold start takes 15–25 seconds (model load + adapter attach). Subsequent requests on a warm Space respond in 2–5 seconds depending on token budget.

---

## What This Project Showed

Three takeaways:

**1. Fine-tuning a strong base model on small, clean data beats training a smaller specialised model from scratch.** 350 examples were enough to lift ROUGE-L by 27 absolute points because the base model already knew how to read; it just did not know how to format.

**2. QLoRA makes serious VLM fine-tuning accessible.** 4-bit base + rank-16 adapters fits comfortably on a single T4. There is no need for a multi-A100 cluster for this class of project.

**3. Output-format alignment is most of the work for instruction-style fine-tuning.** Iterating on the prompt template and carefully cleaning the ground-truth Markdown paid off more than any hyperparameter sweep.

---

## Links

- 🤗 **[Live Demo on Hugging Face Spaces](https://huggingface.co/spaces/prospect01/document-to-markdown)**
- 💻 **[Source Code on GitHub](https://github.com/Zubair-Ali-Sandhu/vision-to-markdown)**
- 📚 **[Qwen2-VL Technical Report (Wang et al., 2024)](https://arxiv.org/abs/2409.12191)**
- 📚 **[QLoRA: Efficient Finetuning of Quantized LLMs (Dettmers et al., 2023)](https://arxiv.org/abs/2305.14314)**
- 📚 **[Nougat: Neural Optical Understanding for Academic Documents (Blecher et al., 2023)](https://arxiv.org/abs/2308.13418)**
      `,
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "Gemini_Generated_Image_b5qfgpb5qfgpb5qf (Copy).png",
    description:
      "I am available on almost every social media. You can message me on any of the platform, or book a free consultation on upwork to discuss your idea I will reply within 24 hours. Let's build together! ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.",
    link: "https://zubairsandhu.dev/blogs",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Lahore,Punjab, Pakistan",
    locality: "Lahore",
    country: "Pakistan",
    region: "Punjab",
    postalCode: "53100",
    streetAddress: "",
    avatar_image_path: "address_image.svg",
    location_map_link:
      "https://www.google.com/maps/place/Lahore,+Punjab,+Pakistan/@31.5203696,74.3587473,12z/data=!3m1!4b1!4m5!3m4!1s0x391904cbdffebcb:0x7cfb9e8bd6d9cba!8m2!3d31.5203696!4d74.3587473",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  // certifications,
  experience,
  projectsHeader,
  // publicationsHeader,
  // publications,
  blogsSection,
  contactPageData,
};
